module.exports = __webpack_public_path__ + "src/assets/models/injection/vials/blue_med_vial.fbx";